import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  housekeeperPrestations(filter) {
    return Api()
      .get('/housekeeperprestations', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  formatRes(e) {
    return e;
  },
};
